import React, { useCallback, useEffect, useState } from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';
import img from '../../assets/images/bg-auth.jpg';
import logo from '../../assets/images/report/Cooke_CL_Big-removebg-preview2.png';
import logo2 from '../../assets/images/report/cooke-logo-upgrade2.png';
import moment from 'moment';

import regular from '../../assets/fonts/Montserrat/Montserrat-Regular.ttf';
import bold from '../../assets/fonts/Montserrat/Montserrat-Bold.ttf';
import semibold from '../../assets/fonts/Montserrat/Montserrat-SemiBold.ttf';
import medium from '../../assets/fonts/Montserrat/Montserrat-Medium.ttf';
import { useDispatch } from 'react-redux';
import { getImageToken } from '../../helpers/file_manager/backend_helper';


Font.register({
    family: 'Montserrat',
    fonts: [
        { src: regular, fontWeight: 'normal' },
        { src: bold, fontWeight: 'bold' },
        { src: semibold, fontWeight: '600' },
        { src: medium, fontWeight: '500' },
    ],
});

// import axios from 'axios';

// const convertBlobToDataUrl = async (blob) => {
//     const reader = new FileReader();
//     return new Promise((resolve, reject) => {
//         reader.onloadend = () => resolve(reader.result);
//         reader.onerror = reject;
//         reader.readAsDataURL(blob);
//     });
// };


const CoverPage = async ({ page, period, onPageLoad }) => {
    // const [imageUrl, setImageUrl] = useState(null);
    const formattedPeriod = moment(period, 'MMM YYYY').format('MM|YY');
    // const publicImageUrl = page.elements[0]?.image?.url;

    // useEffect(() => {
    //     const fetchImageUrl = async () => {
    //         if (publicImageUrl) {
    //             try {
    //                 const imageSrc = await getImageToken(publicImageUrl);
    //                 setImageUrl(imageSrc);
    //                 onPageLoad();
    //             } catch (error) {
    //                 console.error('Error loading image:', error);
    //             }
    //         }
    //     };

    //     fetchImageUrl();
    // }, [publicImageUrl, onPageLoad]);

    // // Evita renderizar hasta que imageUrl esté disponible
    // if (!imageUrl) {
    //     return <Text>Loading...</Text>;
    // }

    return (
        <Document>
            <Page size="A4" style={styles.pageCover}>
                <View style={styles.pageCover_imageSection}>
                    <Image style={styles.pageCover_mainImage} src={img} />
                </View>
                <View style={styles.pageCover_infoSection}>
                    <Text style={styles.pageCover_dateText}>{formattedPeriod}</Text>
                    <Text style={styles.pageCover_titleText}>{page.name}</Text>
                    <Text style={styles.pageCover_subtitleText}>Cooke Aquaculture Chile</Text>
                </View>
            </Page>
        </Document>
    );
};






// const CoverPage = ({ page, period, onPageLoad }) => {
//     const dispatch = useDispatch();
//     const [imageBase64, setImageBase64] = useState(null);
//     const formattedPeriod = moment(period, 'MMM YYYY').format('MM|YY');
//     const imageUrl = page.elements[0]?.image?.url;

//     useEffect(() => {
//         const fetchImageBase64 = async () => {
//             if (imageUrl) {
//                 const base64 = await getImageToken(imageUrl);
//                 setImageBase64(base64);
//                 onPageLoad();
//             }
//         };
    
//         fetchImageBase64();
//     }, [imageUrl, onPageLoad]);
    

//     return (
//         <Page size={{ width: 1280, height: 717 }} style={styles.pageCover}>
//             <View style={styles.pageCover_imageSection}>
//                 <Image style={styles.pageCover_mainImage} src={imageBase64} />
//             </View>
//             <View style={styles.pageCover_infoSection}>
//                 <View style={styles.pageCover_textContainer}>
//                     <Text style={styles.pageCover_dateText}>{formattedPeriod}</Text>
//                     <Text style={styles.pageCover_titleText}>{page.name}</Text>
//                     <Text style={styles.pageCover_subtitleText}>Cooke Aquaculture Chile</Text>
//                 </View>
//                 <Image style={styles.logo} src={logo} />
//             </View>
//         </Page>
//     );
// };

const IndexPage = ({ onPageLoad }) => {
    useEffect(() => {
        onPageLoad();
    }, [onPageLoad]);

    return (
        <Page size={{ width: 1280, height: 717 }} style={styles.pageIndex}>
            <View style={styles.pageIndex_indexSection}>
                <Text style={styles.pageIndex_indexTitle}>Index</Text>
                <Text style={styles.pageIndex_indexItem}>I. Operational Costs</Text>
                <Text style={styles.pageIndex_indexItem}>II. Income Statement</Text>
                <Text style={styles.pageIndex_indexItem}>III. Salt Water KPIs Evolution</Text>
                <Text style={styles.pageIndex_indexItem}>IV. Sales</Text>
                <Text style={styles.pageIndex_indexItem}>V. Tepual Processing Plant</Text>
                <Text style={styles.pageIndex_indexItem}>VI. Sales Prices</Text>
                <Text style={styles.pageIndex_indexItem}>VII. Annexes</Text>
                <Text style={styles.pageIndex_indexItem}>VIII. Summary</Text>
            </View>
            <View style={styles.pageIndex_imageSection}>
                <Image style={styles.pageIndex_mainImage} src={img} />
                <Image style={styles.pageIndex_logo} src={logo} />
            </View>
        </Page>
    );
};

const PageGeneral = ({ page, onPageLoad }) => {
    useEffect(() => {
        onPageLoad();
    }, [onPageLoad]);

    return (
        <Page size={{ width: 1280, height: 717 }} style={styles.PageGeneral_page}>
            <View style={styles.PageGeneral_header}>
                <Image style={styles.PageGeneral_logo} src={logo2} />
                <Text style={styles.PageGeneral_title}>{page.name}</Text>
            </View>
            <View style={styles.PageGeneral_content}>
                {page.elements[0]?.png ? (
                    <Image src={page.elements[0].png} style={{ width: '100%', height: 'auto' }} />
                ) : (
                    <Text>Error loading image</Text>
                )}
            </View>
            <View style={styles.PageGeneral_footer}>
                <Text style={styles.PageGeneral_footerText}>{page.elements[0]?.text || ''}</Text>
            </View>
            <Text
                style={styles.pageNumber}
                render={({ pageNumber, totalPages }) => `${pageNumber} | ${totalPages}`}
                fixed
            />
        </Page>
    );
};


const SectionPage = () => (
    <Page size={{ width: 1280, height: 717 }} style={styles.pageSection}>
        <View style={styles.pageSection_container}>
            <View style={styles.pageSection_infoSection}>
                <View style={styles.pageSection_textContainer}>
                    <Text style={styles.pageSection_titleText}>Nombre de la sección</Text>
                    <Text style={styles.pageSection_subtitleText}>Subtitulo</Text>
                </View>
            </View>
            <View style={styles.pageSection_imageSection}>
                <Image style={styles.pageSection_mainImage} src={img} />
            </View>
        </View>
        <Text
            style={styles.pageNumber}
            render={({ pageNumber, totalPages }) => `${pageNumber} | ${totalPages}`}
            fixed
        />
    </Page>
);


const renderSelectedPage = (pageType, index, page, period, onPageLoad) => {
    switch (pageType) {
        case 'CoverPage':
            return (
                <React.Fragment key={index}>
                    <CoverPage page={page} period={period} onPageLoad={onPageLoad} />
                    <IndexPage onPageLoad={onPageLoad} />
                </React.Fragment>
            );
        case 'TitleGraphPage':
            return <PageGeneral key={index} page={page} onPageLoad={onPageLoad} />;
        default:
            console.log("Unknown page type:", pageType);
            return null;
    }
};





const ReportFile = ({ report, onLoadComplete }) => {
    const [loadedPages, setLoadedPages] = useState(0);

    useEffect(() => {
        if (loadedPages === report.pages.length) {
            onLoadComplete(true); // Notifica a PDFReport que el ReportFile está listo
        }
    }, [loadedPages, report.pages.length, onLoadComplete]);

    const handlePageLoad = useCallback(() => {
        setLoadedPages(prev => prev + 1);
    }, []);
    

    return (
        <Document>
            {report.pages.map((page, index) => (
                renderSelectedPage(page.page_type.code, index, page, report.period, handlePageLoad)
            ))}
            <SectionPage onPageLoad={handlePageLoad} />
        </Document>
    );
};


const styles = StyleSheet.create({
    pageNumber: {
        position: 'absolute',
        bottom: 10,
        left: 10,
        fontSize: 12,
        fontFamily: 'Montserrat',
        color: '#FFF',
    },
    pageCover: {
        flexDirection: 'row',
        backgroundColor: '#001f5c',
        padding: 0,
    },
    pageCover_imageSection: {
        width: '75%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
    },
    pageCover_mainImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    pageCover_infoSection: {
        width: '25%',
        height: '100%',
        backgroundColor: '#001f5c',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 10,
        flexDirection: 'column',
    },
    pageCover_textContainer: {
        width: '70%',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        marginTop: 30,
    },
    pageCover_dateText: {
        fontSize: 39,
        fontFamily: 'Montserrat',
        color: '#426ba8',
        textAlign: 'right',
        marginBottom: 10,
    },
    pageCover_titleText: {
        fontSize: 20,
        fontFamily: 'Montserrat',
        fontWeight: '600',
        color: '#FFFFFF',
        width: '100%',
        textAlign: 'right',
        textTransform: 'uppercase',
    },
    pageCover_subtitleText: {
        fontSize: 14,
        fontFamily: 'Montserrat',
        color: '#FFFFFF',
        width: '100%',
        textAlign: 'right',
        marginBottom: 20,
    },
    logo: {
        width: '70%',
        height: 'auto',
        alignSelf: 'center',
        marginBottom: 30,
    },
    pageIndex: {
        flexDirection: 'row',
        backgroundColor: '#FFFFFF',
        padding: 0,
    },
    pageIndex_indexSection: {
        width: '75%',
        backgroundColor: '#001f5c',
        padding: 100,
        justifyContent: 'center',
    },
    pageIndex_infoSection: {
        width: '25%',
        height: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 10,
        flexDirection: 'column',
    },
    pageIndex_indexTitle: {
        fontSize: 33,
        fontFamily: 'Montserrat',
        fontWeight: 'bold',
        marginBottom: 40,
        color: '#426ba8',
    },
    pageIndex_indexItem: {
        fontSize: 19,
        fontFamily: 'Montserrat',
        marginBottom: 10,
        color: '#ffffff',
    },
    pageIndex_imageSection: {
        width: '25%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        position: 'relative',
    },
    pageIndex_mainImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    pageIndex_logo: {
        position: 'absolute',
        width: '70%',
        height: 'auto',
        bottom: 30,
        marginLeft: '15%',
    },
    pageSection_container: {
        flexDirection: 'row',
        height: '100%',
    },
    pageSection_imageSection: {
        width: '75%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
    },
    pageSection_mainImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    pageSection_infoSection: {
        width: '25%',
        height: '100%',
        backgroundColor: '#001f5c',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: 10,
        paddingBottom: 100,
        flexDirection: 'column',
    },
    pageSection_textContainer: {
        width: '70%',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        marginTop: 30,
    },
    pageSection_titleText: {
        fontSize: 20,
        fontFamily: 'Montserrat',
        fontWeight: '600',
        color: '#FFFFFF',
        width: '100%',
        textAlign: 'right',
        textTransform: 'uppercase',
        whiteSpace: 'normal',
        hyphens: 'none',
        wordBreak: 'keep-all',
        overflowWrap: 'normal',
    },
    pageSection_subtitleText: {
        fontSize: 14,
        fontFamily: 'Montserrat',
        color: '#FFFFFF',
        width: '100%',
        textAlign: 'right',
        marginBottom: 20,
    },
    PageGeneral_page: {
        flexDirection: 'column',
    },
    PageGeneral_header: {
        height: 60,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottomWidth: 1,
        borderBottomColor: '#001f5c',
        paddingLeft: 40,
        paddingTop: 10,
        paddingRight: 40,
        paddingBottom: 10,
    },
    PageGeneral_logo: {
        height: '95%',
        width: 'auto',
    },
    PageGeneral_title: {
        fontSize: 24,
        fontFamily: 'Montserrat',
        color: '#001f5c',
        textAlign: 'right',
    },
    PageGeneral_content: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 40,
        marginTop: 20,
        marginRight: 40,
        marginBottom: 20,
    },
    PageGeneral_footer: {
        backgroundColor: '#001f5c',
        height: 150
    },
    PageGeneral_footerText: {
        fontSize: 15,
        fontFamily: 'Montserrat',
        fontWeight: 500,
        color: '#FFFFFF',
        textAlign: 'left',
        paddingLeft: 40,
        paddingTop: 20,
        paddingRight: 40,
        paddingBottom: 20,
    },
});



export default ReportFile;
